module.exports = __webpack_public_path__ + "static/media/19ESCAP41.14d54f1d.jpg";